import { useEffect, useState, type ReactNode } from 'react';
import { loadRuntimeConfig, type RuntimeConfig } from './runtimeConfig';
import { RuntimeConfigContext } from './RuntimeConfigContext';
import { CenterCard } from '@/components/CenterCard';

export function ConfigProvider({ children }: { children: ReactNode }) {
    const [config, setConfig] = useState<RuntimeConfig | null>(null);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        loadRuntimeConfig()
            .then(setConfig)
            .catch((err: Error) => setError(err.message));
    }, []);

    if (error) {
        return (
            <CenterCard title="Không thể tải cấu hình" showSpinner={false}>
                <p className="portal-callback-error">{error}</p>
            </CenterCard>
        );
    }
    if (!config) {
        return <CenterCard title="Đang tải…" />;
    }
    return <RuntimeConfigContext.Provider value={config}>{children}</RuntimeConfigContext.Provider>;
}
